import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Heading from "@/components/atoms/Heading";
import { SettingsFormContent, SettingsHeader } from "./index";
import { Grid, Group } from "@mantine/core";
import Text from "@/components/atoms/Text";
import Stack from "@/components/atoms/Stack";
import DocumentTable from "@/components/organisms/DocumentTable";
import CTA from "@/components/atoms/CTA";
import { UploadFileModal } from "@/components/organisms/UploadFileModal";
import Checkbox from "@/components/atoms/Checkbox";
import { DEFAULT_DOCUMENTS_COLUMN } from "../../organisms/DocumentTable/const/default";

export default function DocumentSettings() {
  const [open, setOpen] = useState<boolean>(false);
  const [showDeactivated, setShowDeactivated] = useState<boolean>(false);
  const { t } = useTranslation();

  const handleShowDeactivated = (value: boolean) => {
    // pass the value to url
    const url = new URL(window.location.href);
    url.searchParams.set("showDeactivated", value.toString());
    window.history.pushState({}, "", url);
    setShowDeactivated(value);
  };

  useEffect(() => {
    const url = new URL(window.location.href);
    const showDeactivatedParam = url.searchParams.get("showDeactivated");
    if (showDeactivatedParam !== null) {
      setShowDeactivated(showDeactivatedParam === "true");
    }
  }, []);

  return (
    <>
      <Stack>
        <Heading order={2} styleOrder={4} tt="uppercase" data-testid={"page-header"}>
          {t("settings:navigation.documents")}
        </Heading>
        <SettingsFormContent>
          <Grid>
            <SettingsHeader>
              <Text size="md" strong={true} display="technical" tt="uppercase" data-testid={"table-header"}>
                {t("settings:documents.myDocuments")}
              </Text>
              <Group align={"flex-end"}>
                <Checkbox
                  labelPosition={"left"}
                  data-testid={"deactivated-checkbox"}
                  checked={showDeactivated}
                  onChange={(e) => handleShowDeactivated(e.target.checked)}
                  mb={8}
                  label={t("actions:showDeactivated")}
                />
                <CTA intent={"primary"} onClick={() => setOpen(!open)} data-testid={"upload-button"}>
                  {t("actions:uploadDocument")}
                </CTA>
              </Group>
            </SettingsHeader>
            <Grid.Col span={12}>
              <DocumentTable showDeactivated={showDeactivated} visibleColumns={DEFAULT_DOCUMENTS_COLUMN} />
            </Grid.Col>
          </Grid>
        </SettingsFormContent>
      </Stack>
      <UploadFileModal open={open} setOpen={setOpen} />
    </>
  );
}
